module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-pop-layer"
  }, [_c('div', {
    staticClass: "m-flex-row"
  }, [_c('div', {
    staticClass: "m-pop-content"
  }, [_c('div', {
    staticClass: "m-pop-title"
  }, [_c('p', [_vm._v("确认预定信息")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.closeLayer(1, 0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-pop-center"
  }, [_c('div', {
    staticClass: "m-flex-row m-info"
  }, [_c('div', [_vm._v("姓名")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.comdata.name))])]), _vm._v(" "), _c('div', {
    staticClass: "m-flex-row m-info"
  }, [_c('div', [_vm._v("婚期")]), _vm._v(" "), (_vm.comdata.weddingDate) ? _c('div', [_vm._v(_vm._s(_vm.weddata))]) : _c('div', [_vm._v("未定")])]), _vm._v(" "), _c('div', {
    staticClass: "m-flex-row m-info"
  }, [_c('div', [_vm._v("联系电话")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.comdata.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "m-flex-row m-info"
  }, [_c('div', [_vm._v("婚礼服务")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.comdata.service))])]), _vm._v(" "), _c('div', {
    staticClass: "m-flex-row m-info"
  }, [_c('div', [_vm._v("婚礼顾问")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.comdata.weddingBroker))])])]), _vm._v(" "), _c('div', {
    staticClass: "m-pop-bottom"
  }, [_c('a', {
    staticClass: "m-btn",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.goPay
    }
  }, [_vm._v("支付定金 ¥" + _vm._s(_vm.comdata.amount / 100))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c26248c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agent/comfirm-info.vue
// module id = 652
// module chunks = 1